__turbopack_context__.v({
  "categories": "categories-module-scss-module__wnAMZq__categories",
  "section-title": "categories-module-scss-module__wnAMZq__section-title",
  "skeleton-card": "categories-module-scss-module__wnAMZq__skeleton-card",
  "skeleton-cards": "categories-module-scss-module__wnAMZq__skeleton-cards",
  "skeleton-illustration": "categories-module-scss-module__wnAMZq__skeleton-illustration",
});
